<template>

    <div class="dash-banner-index">
        <a  v-if="link == '#'"><img alt="Banner" :src="img" :data-ba-i="dataBA"></a>
        <a  v-else-if="link == 'FACEBOOK'" @click="emitOpenModal()" href="#"><img alt="Banner" :src="img" :data-ba-i="dataBA"></a>
        <a  v-else-if="link == '#facebook'" @click="emitOpenModal()" href="#"><img alt="Banner" :src="img" :data-ba-i="dataBA"></a>
        <a  v-else
            :href="link"
            :target="makeTarget(link)"
            :rel="makeRel(link)"
            >
            <img alt="Banner" :src="img" :data-ba-i="dataBA">
        </a>
    </div>
</template>

<script>
    export default {
        name: "dv5-right-banner-card",
        props: [ 'view', "app" ],
        data() {
            return {
                bannerOne:     this.view[1],
                linkBannerOne: this.view['link_1'],
                bannerTwo:     this.view[2],
                linkBannerTwo: this.view['link_2'],
                facebookLinks: [],
                processingModal : false,
            };
        },
        mounted() {
            // console.log(this.view, this.app);
        },

        methods: {
            makeTarget: function(url) {
                //if URL contains office.builderall or is relative url, open self. Else, open blank
                return url && ( url.indexOf("://office.builderall") > -1 || url.indexOf('://') == -1 ) ? '_self' : '_blank';
            },

            makeRel: function(url) {
                return this.makeTarget(url) == '_blank' ? 'noopener' : '';
            },
            emitOpenModal() {
                this.$emit('openModal')
            }
        },

        computed: {
            link() {
                // if (this.app == 'banners_ba5') {
                return this.view.action_link;
                // } else {
                //     return this.view.link;
                // }
            },

            img() {
                // if (this.app == 'banners_ba5') {
                return this.view.banner;
                // } else {
                //     return this.view.img;
                // }
            },

            dataBA() {
                // if (this.app == 'banners_ba5') {
                return '"dashboard-banner-2"';
                // } else {
                //     return this.view['data-ba-i'];
                // }

            }
        }
    }
</script>

<style lang="scss" scoped>
    .dash-banner-index {
        text-align: center;
        border-radius: 4px!important;
        img {
            border-radius: 4px!important;
            width: 350px;
            height: 260px;
        }
        a{
            cursor: default;
            border-radius: 4px!important;
            width: 100%;
            display: block!important;
            height: auto!important;
            margin: 0!important;
            padding: 0!important;
            &[href]{
                cursor: pointer;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/banners/RightBannerCard.vue